import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ConfirmActionDialog from "../../../components/ConfirmActionDialog";
import LeaveApi from "../../../axios/LeaveAndHoliday/LeaveApi";

const CorfirmRejectRequestDialog = ({
  onClose,
  onRefresh,
  formData,
  onCloseDetail,
  leaveInfo,
  onLoadingChange,
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { updateLeaveRequestStatus } = LeaveApi();
  const { t } = useTranslation();

  const handleCloseDialog = () => {
    if (isSubmitting) return;
    onClose();
  };

  const handleRejectRequest = async () => {
    setIsSubmitting(true);
    onLoadingChange?.(true);
    try {
      const payload = {
        leaveRequestId: leaveInfo.leaveRequestId ?? leaveInfo.leaveId,
        responseReason: formData.approveReason,
        requestStatus: "REJECTED",
        langId: localStorage.getItem("i18nextLngId"),
      };
      const response = await updateLeaveRequestStatus(payload);
      const isSuccess =
        response?.data?.message === "Successful" ||
        response?.data?.message === "Thành công" ||
        response?.data?.responseCode === 1085;

      if (isSuccess) {
        toast.success(t("common.reject-successfully"));
        onClose();
        onCloseDetail?.();
        onRefresh?.();
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || error.message);
    } finally {
      setIsSubmitting(false);
      onLoadingChange?.(false);
    }
  };

  return (
    <ConfirmActionDialog
      open
      variant="warning"
      title={t("common.content-172")}
      subtitle={t("common.confirm-reject-request")}
      confirmText={t("button.confirm")}
      loading={isSubmitting}
      onClose={handleCloseDialog}
      onConfirm={handleRejectRequest}
    />
  );
};

export default CorfirmRejectRequestDialog;
